import React, { useState, useEffect } from 'react';
import './Dashboard.css';
import { giveawaysAPI } from '../utils/api';

function Dashboard({ currentUser, giveaways }) {
  const [stats, setStats] = useState({
    totalEntries: 0,
    activeGiveaways: 0,
    wins: 0,
    winRate: 0,
  });
  const [recentActivity, setRecentActivity] = useState([]);
  const [upcomingGiveaways, setUpcomingGiveaways] = useState([]);

  useEffect(() => {
    if (currentUser && giveaways) {
      // Calculate user stats
      let totalEntries = 0;
      const userEntries = currentUser.entries || {};
      Object.values(userEntries).forEach(entry => {
        if (new Date(entry.expiresAt) > new Date()) {
          totalEntries += entry.count || 0;
        }
      });

      const active = giveaways.filter(g => g.status === 'active');
      setStats({
        totalEntries,
        activeGiveaways: active.length,
        wins: 0, // Would come from backend
        winRate: totalEntries > 0 ? ((0 / totalEntries) * 100).toFixed(1) : 0,
      });

      // Get upcoming giveaways (ending soon)
      const upcoming = active
        .sort((a, b) => new Date(a.endsAt) - new Date(b.endsAt))
        .slice(0, 5);
      setUpcomingGiveaways(upcoming);
    }
  }, [currentUser, giveaways]);

  if (!currentUser) {
    return (
      <div className="dashboard-page">
        <div className="dashboard-container">
          <h1>Dashboard</h1>
          <p>Please log in to view your dashboard.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="dashboard-page">
      <div className="dashboard-container">
        <div className="dashboard-header">
          <h1>📊 Dashboard</h1>
          <p>Welcome back, {currentUser.discordUsername}!</p>
        </div>

        <div className="dashboard-stats-grid">
          <div className="stat-card">
            <div className="stat-icon">🎯</div>
            <div className="stat-content">
              <h3>{stats.totalEntries}</h3>
              <p>Total Entries</p>
            </div>
          </div>
          <div className="stat-card">
            <div className="stat-icon">🎁</div>
            <div className="stat-content">
              <h3>{stats.activeGiveaways}</h3>
              <p>Active Giveaways</p>
            </div>
          </div>
          <div className="stat-card">
            <div className="stat-icon">🏆</div>
            <div className="stat-content">
              <h3>{stats.wins}</h3>
              <p>Wins</p>
            </div>
          </div>
          <div className="stat-card">
            <div className="stat-icon">📈</div>
            <div className="stat-content">
              <h3>{stats.winRate}%</h3>
              <p>Win Rate</p>
            </div>
          </div>
        </div>

        <div className="dashboard-grid">
          <div className="dashboard-widget">
            <h2>🎯 Your Entries</h2>
            <div className="entries-list">
              {Object.entries(currentUser.entries || {}).map(([giveawayId, entry]) => {
                const giveaway = giveaways.find(g => g._id === giveawayId || g.id === giveawayId);
                if (!giveaway || new Date(entry.expiresAt) <= new Date()) return null;
                return (
                  <div key={giveawayId} className="entry-item">
                    <div className="entry-info">
                      <h4>{giveaway.title}</h4>
                      <p>{entry.count} entries</p>
                    </div>
                    <div className="entry-expiry">
                      Expires: {new Date(entry.expiresAt).toLocaleDateString()}
                    </div>
                  </div>
                );
              })}
              {Object.keys(currentUser.entries || {}).length === 0 && (
                <p className="empty-state">No active entries</p>
              )}
            </div>
          </div>

          <div className="dashboard-widget">
            <h2>⏰ Upcoming Giveaways</h2>
            <div className="upcoming-list">
              {upcomingGiveaways.map(giveaway => (
                <div key={giveaway._id || giveaway.id} className="upcoming-item">
                  <h4>{giveaway.title}</h4>
                  <p>Ends: {new Date(giveaway.endsAt).toLocaleDateString()}</p>
                  <span className="participants">{giveaway.participants || 0} participants</span>
                </div>
              ))}
              {upcomingGiveaways.length === 0 && (
                <p className="empty-state">No upcoming giveaways</p>
              )}
            </div>
          </div>
        </div>

        <div className="dashboard-widget full-width">
          <h2>📊 Activity Overview</h2>
          <div className="activity-chart">
            <div className="chart-placeholder">
              <p>Activity chart would go here</p>
              <div className="chart-bars">
                {[65, 80, 45, 90, 70, 85, 60].map((height, i) => (
                  <div key={i} className="chart-bar" style={{ height: `${height}%` }}></div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Dashboard;

